import React, { useState, createContext } from "react";

export const PasswordContext = createContext({
  email: "",
  setEmail: () => {},
});

const ForgotPasswordProvider = ({ children }) => {
  const [email, setEmail] = useState("");

  return (
    <PasswordContext.Provider value={{ email, setEmail }}>
      {children}
    </PasswordContext.Provider>
  );
};

export default ForgotPasswordProvider;
